<template>
  <RevCard
    class="space-y-24 p-24"
    data-qa="explanation-block"
    data-test="explanation-block"
  >
    <XrInformationRow
      :description="i18n(translations.informationSectionCreditCardDescription)"
      :title="i18n(translations.informationSectionCreditCardTitle)"
    >
      <template #icon>
        <IconCreditCard />
      </template>
    </XrInformationRow>
    <XrInformationRow
      :description="
        i18n(translations.informationSectionDeliveryDateDescription)
      "
    >
      <template #icon>
        <IconTruckExpress />
      </template>
      <template #title>
        <span
          class="body-1-bold"
          data-qa="delivery-date"
          data-test="delivery-date"
        >
          {{
            i18n(translations.informationSectionDeliveryDateTitle, {
              min: i18n.date(new Date(deliveryDate.min), DATE_FORMAT_DELIVERY),
              max: i18n.date(new Date(deliveryDate.max), DATE_FORMAT_DELIVERY),
            })
          }}
        </span>
      </template>
    </XrInformationRow>
    <XrInformationRow
      :description="
        i18n(translations.informationSectionReturnDeadlineDescription)
      "
    >
      <template #icon>
        <IconPackage />
      </template>
      <template #title>
        <span
          class="body-1-bold"
          data-qa="deadline-date"
          data-test="deadline-date"
        >
          {{
            i18n(translations.informationSectionReturnDeadlineTitle, {
              deadline: i18n.date(new Date(deadline), DATE_FORMAT_DEADLINE),
            })
          }}
        </span>
      </template>
    </XrInformationRow>
  </RevCard>
</template>

<script setup lang="ts">
import type { DateDate } from '@backmarket/http-api/src/standards/DateDate'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconCreditCard } from '@ds/icons/IconCreditCard'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import XrInformationRow from '~/scopes/customer-care/resolution/components/ExpressReplacement/details/XrInformationRow/XrInformationRow.vue'
import {
  DATE_FORMAT_DEADLINE,
  DATE_FORMAT_DELIVERY,
} from '~/scopes/customer-care/resolution/pages/express-replacement/details/ExpressReplacementDetails.constants'

import translations from './XrInformationSection.translations'

interface ExplanationBlockProps {
  deliveryDate: {
    min: DateDate
    max: DateDate
  }
  deadline: string
}

defineProps<ExplanationBlockProps>()

const i18n = useI18n()
</script>
